import styles from "@/components/ai-icon.module.css";
import clsx from "clsx";
import { JSX } from "react";

interface AiIconProps {
	className?: string;
}

function AiIcon({ className }: AiIconProps): JSX.Element {
	return <div className={clsx(styles["ai-icon"], className)}>AI</div>;
}

export default AiIcon;
